export enum EFORM
{
    ADD = 'add',
    UPDATE = 'update'
}